import { API_ENDPOINT, useJwtToken } from 'helper';
import { useQuery } from 'react-query';

export const PAGE_SIZE = 20;

export const useGetWarranties = (
    sortDirection,
    sortField,
    currentPage,
    search,
    filterBy
) => {
    const accessToken = useJwtToken();
    const warrantiesResponse = useQuery(
        ['warranties', currentPage, search, filterBy, sortField, sortDirection],
        () =>
            fetchWarranties(
                sortDirection,
                sortField,
                currentPage,
                search,
                filterBy,
                accessToken
            ),
        {
            keepPreviousData: true, // Keep previous page data while fetching the next page
            staleTime: 5 * 60 * 1000, // Data is considered fresh for 5 minutes
            retry: 2,
            enabled: !!accessToken, // Only run the query if accessToken is available
        }
    );
    return warrantiesResponse;
};

const fetchWarranties = async (
    sortDirection,
    sortField,
    currentPage,
    search,
    filterBy,
    accessToken
) => {
    const sortOrder = sortDirection === 1 ? 'asc' : 'desc';
    const warrantyURL = new URL(`${API_ENDPOINT}/warranties?`);
    warrantyURL.searchParams.append(`${filterBy}`, search);
    warrantyURL.searchParams.append('sortField', sortField);
    warrantyURL.searchParams.append('sortOrder', sortOrder);
    warrantyURL.searchParams.append('from', (currentPage - 1) * PAGE_SIZE);
    warrantyURL.searchParams.append('size', PAGE_SIZE);

    try {
        const response = await fetch(warrantyURL.toString(), {
            headers: {
                Authorization: accessToken,
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Unknown error occurred');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching warranties:', error.message);
    }
};
